import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";

function ProfileBottomTab() {
  const navigate = useNavigate();

  const [value, setValue] = React.useState(0);

  return (
    <>
      <div className="proFileBotMain">
        <div className="mobBottomNavMain">
          <Box>
            <BottomNavigation
              showLabels
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            >
              <BottomNavigationAction
                onClick={() => navigate("/MobFamilyDetails")}
                label="Family Info"
                icon={<RestoreIcon />}
              />
              <BottomNavigationAction
                onClick={() => navigate("/MobileVehicleinfo")}
                label="Vehicle Info"
                icon={<FavoriteIcon />}
              />
              <BottomNavigationAction
                onClick={() => navigate("/MobileTenantInfo")}
                label="Tenant Info"
                icon={<LocationOnIcon />}
              />
              <BottomNavigationAction
                onClick={() => navigate("/MobileTenantVehicle")}
                label="Tenant Vehicle"
                icon={<LocationOnIcon />}
              />
            </BottomNavigation>
          </Box>
        </div>
      </div>
      <div className="mobNavFixedPatch"></div>
    </>
  );
}

export default ProfileBottomTab;
